import { motion } from "framer-motion";

export default function Header() {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.4 }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="site-header"
    >
      <div className="backdrop-blur-md bg-white/85 border-b border-navy/10">
        <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 lg:px-12 py-4">
          <a href="#top" className="flex items-center gap-3 group" data-testid="brand-mark">
            <img src="/peak-mountains.png" alt="" className="h-7 w-auto" aria-hidden="true" />
            <span className="font-display font-black text-navy tracking-tight text-lg uppercase leading-none">
              Peak Disposal
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-10 text-[11px] tracking-[0.2em] uppercase font-semibold text-navy">
            <span data-testid="header-tagline">Reliable Service You Can Trust</span>
          </nav>

          <div className="hidden sm:block" />
        </div>
      </div>
    </motion.header>
  );
}
